<template>
  <SbIcon :variation="icon" />
</template>

<script>
import SbIcon from '@src/components/Icons/SbIcon.vue';

const iconVariationMap = {
  default: 'check',
  'check-box': 'check_box',
  'check-box-outline': 'check_box_outline_blank',
};

export default {
  name: 'CheckmarkIcon',
  components: { SbIcon },
  props: {
    /**
     * Style variation to give additional meaning.
     * `default | check-box | check-box-outline`
     */
    variation: {
      type: String,
      default: 'default',
      validator: (val) => val.match(/(default|)/),
    },
  },
  computed: {
    icon() {
      return iconVariationMap[this.variation];
    },
  },
};
</script>

<style lang='scss'>
</style>
